<template>
  <PopUpContents
    ref="popup"
    width="42rem"
    height="38rem"
  >
    <div class="p-3 m-2">
      <div class="row h-40">
        <p class="bb-page-title mt-3 mb-2">{{ title }}</p>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-7 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="runeName"
              id="rune-linked-values-name"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="rune-linked-values-name"
              >Rune Name</label
            >
          </div>
        </div>
        <div class="col-5">
          <div
            class="btn-group special mt-4"
            role="group"
          >
            <button
              v-if="cancelButton"
              type="button"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              {{ cancelButton }}
            </button>
            <button
              v-if="okButton"
              type="button"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              {{ okButton }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-3"></div>
      <p class="bb-hdg mt-3 mb-3">{{ message }}</p>
      <p
        v-if="subject"
        class="bb-sub-hdg mt-2 mb-3"
      >
        {{ subject }}
      </p>
      <div class="row mt-3 mb-3">
        <div class="form-group">
          <div class="form-floating">
            <div
              class="form-control bb-linked-values-scroll rune-linked-values-select"
            >
              <div
                v-for="detail in details"
                :key="detail"
                class="bb-linked-values-item rune-linked-values-item"
              >
                {{ detail }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'

export default {
  name: 'RuneLinkedValuesDialog',
  components: {
    PopUpContents,
  },
  data: () => ({
    title: undefined,
    message: undefined,
    subject: undefined,
    runeName: undefined,
    details: [],
    okButton: undefined,
    cancelButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.subject = opts.subject
      this.runeName = opts.runeName
      this.details = Array.isArray(opts.details) ? opts.details : []
      this.okButton = opts.okButton
      this.cancelButton = opts.cancelButton

      if (this.details.length === 0) {
        return Promise.resolve({ cancel: false })
      }

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({ cancel: false })
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise({ cancel: true })
    },
  },
}
</script>

<style scoped>
.form-floating .form-control.rune-linked-values-select {
  height: 19rem !important;
  max-height: 19rem !important;
}

.rune-linked-values-item {
  margin-bottom: 0.35rem;
}

.rune-linked-values-item:last-child {
  margin-bottom: 0;
}
</style>
